// Custom Search Section
(function() {
  'use strict';

  class CustomSearch {
    constructor(section) {
      this.section = section;
      this.input = section.querySelector('.field__input');
      this.form = section.querySelector('form.search');
      this.predictiveSearch = section.querySelector('predictive-search');
      this.resultsWrapper = section.querySelector('[data-predictive-search-results-wrapper]');
      this.statusElement = section.querySelector('.predictive-search-status');
      
      if (!this.input || !this.form || !this.predictiveSearch) return;
      
      this.handleInput = this.handleInput.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.fetchResults = this.fetchResults.bind(this);
      
      this.input.addEventListener('input', this.handleInput);
      this.form.addEventListener('submit', this.handleSubmit);

      document.addEventListener('click', (e) => {
        if (!this.section.contains(e.target)) {
          this.predictiveSearch.removeAttribute('open');
        }
      });
    }

    handleInput() {
      const value = this.input.value.trim();
      
      if (value.length > 0) {
        this.predictiveSearch.setAttribute('loading', '');
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
          this.fetchResults(value);
        }, 300);
      } else {
        this.predictiveSearch.removeAttribute('open');
        this.predictiveSearch.removeAttribute('loading');
      }
    }

    async fetchResults(query) {
      try {
        console.log('🔍 Searching for:', query);
        
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=10`;
        console.log('📡 API URL:', url);
        
        const response = await fetch(url);
        const data = await response.json();
        
        console.log('✅ API Response:', data);
        
        this.renderResults(data, query);
        this.predictiveSearch.setAttribute('open', '');
        this.predictiveSearch.removeAttribute('loading');
        
      } catch (error) {
        console.error('❌ Search error:', error);
        this.predictiveSearch.removeAttribute('loading');
      }
    }

    renderResults(data, query) {
      const html = this.buildResultsHTML(data, query);
      
      if (this.resultsWrapper) {
        this.resultsWrapper.innerHTML = html;
      }
      
      // Update status for accessibility
      if (this.statusElement) {
        const results = data.resources?.results || {};
        const productCount = (results.products || []).length;
        const pageCount = (results.pages || []).length;
        const collectionCount = (results.collections || []).length;
        const totalCount = productCount + pageCount + collectionCount;
        this.statusElement.textContent = `${totalCount} results found for "${query}"`;
      }
    }

    buildResultsHTML(data, query) {
      const results = data.resources?.results || {};
      const products = results.products || [];
      const pages = results.pages || [];
      const collections = results.collections || [];

      if (products.length === 0 && pages.length === 0 && collections.length === 0) {
        return `<div style="padding: 2rem; text-align: center; color: #666;">
          No results found for "${query}"
        </div>`;
      }

      let html = '<div class="predictive-search__results-groups-wrapper">';


      // Pages section
      if (pages.length > 0) {
        html += this.buildPagesSection(pages);
      }





      html += '</div>';
      return html;
    }

    buildProductsSection(products) {
      let html = `
        <div class="predictive-search__result-group">
          <div class="predictive-search__result-tabs">
            <div class="predictive-search__result-tab active">
              <span class="predictive-search__result-tab-title">Products (${products.length})</span>
            </div>
          </div>
          <div class="predictive-search-results-wrapper">
            <ul class="predictive-search__results-list predictive-search__results-list_products list-unstyled active" role="group">
      `;

      products.slice(0, 10).forEach((product) => {
        const image = product.featured_image?.url || product.image || '';
        const title = product.title || '';
        const url = product.url || '#';
        const price = product.price ? `$${parseFloat(product.price).toFixed(2)}` : '';
        
        html += `
          <li class="predictive-search__list-item collection-product-card">
            <div class="card-wrapper color-background-1">
              <div class="card card--product">
                <div class="card__inner full-unstyled-link">
                  <div class="media media--transparent" style="padding-bottom: 100%; background: #f5f5f5;">
                    ${image ? `<img src="${image}" alt="${title}" loading="lazy" style="object-fit: cover; width: 100%; height: 100%;">` : ''}
                  </div>
                </div>
              </div>
              <div class="card-information">
                <div class="card-information__wrapper">
                  <h3 class="card__title h5">
                    <a class="full-unstyled-link" href="${url}" title="${title}" style="color: #333; text-decoration: none; font-weight: 500;">${title}</a>
                  </h3>
                  ${price ? `<div style="color: #666; font-size: 0.9em; margin-top: 0.5rem;">${price}</div>` : ''}
                </div>
              </div>
              <a href="${url}" class="link link--overlay card-wrapper__link--overlay"></a>
            </div>
          </li>
        `;
      });

      html += `
            </ul>
          </div>
        </div>
      `;

      return html;
    }

    buildCollectionsSection(collections) {
      let html = `
        <div class="predictive-search__result-group">
          <div class="predictive-search__result-tabs">
            <div class="predictive-search__result-tab active">
              <span class="predictive-search__result-tab-title">Collections (${collections.length})</span>
            </div>
          </div>
          <ul class="predictive-search__results-list predictive-search__results-list_collections list-unstyled active" role="group">
      `;

      collections.slice(0, 5).forEach((collection) => {
        const title = collection.title || '';
        const url = collection.url || '#';
        
        html += `
          <li class="predictive-search__list-item">
            <a href="${url}" class="predictive-search__result-link" style="display: block; padding: 0.75rem 0; border-bottom: 1px solid #eee; color: #333; text-decoration: none;">
              <span>${title}</span>
            </a>
          </li>
        `;
      });

      html += `
          </ul>
        </div>
      `;

      return html;
    }

    buildPagesSection(pages) {
      let html = `
        <div class="predictive-search__result-group">
          <!--div class="predictive-search__result-tabs">
            <div class="predictive-search__result-tab active">
              <span class="predictive-search__result-tab-title">Pages (${pages.length})</span>
            </div>
          </div-->
          <ul class="predictive-search__results-list predictive-search__results-list_pages list-unstyled active" role="group">
      `;

      pages.slice(0, 5).forEach((page) => {
        const title = page.title || '';
        const url = page.url || '#';
        
        html += `
          <li class="predictive-search__list-item">
            <a href="${url}" class="predictive-search__result-link" style="display: block; padding: 0.75rem 0; border-bottom: 1px solid #eee; color: #333; text-decoration: none;">
              <span>${title}</span>
            </a>
          </li>
        `;
      });

      html += `
          </ul>
        </div>
      `;

      return html;
    }

    handleSubmit(e) {
      const value = this.input.value.trim();
      if (!value) {
        e.preventDefault();
      }
    }

    destroy() {
      if (this.input) this.input.removeEventListener('input', this.handleInput);
      if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.custom-search-wrapper').forEach(wrapper => {
      new CustomSearch(wrapper);
    });
  });

  document.addEventListener('shopify:section:load', (e) => {
    const wrapper = e.detail.section.querySelector?.('.custom-search-wrapper');
    if (wrapper) {
      new CustomSearch(wrapper);
    }
  });
})();